import { useEffect, useState } from 'react';
import type { PaigeWatchedFolder } from './paige.global';

export interface WatchedFolderState {
  /** Undefined while loading; null when no computer watches a folder for the job. */
  folder: PaigeWatchedFolder | null | undefined;
  /** The job Paige Scan's Watched folders window opens on; null outside a Paige job. */
  job: { id: string; name: string } | null;
  /** Why the folder could not be read, in Paige's words. */
  error: string | null;
}

/** The job's watched folder and the job itself, read once when the sheet opens. */
export function useWatchedFolder(): WatchedFolderState {
  const channel = window.paigeWorkbench?.watchedFolder;
  const [state, setState] = useState<WatchedFolderState>({
    folder: channel ? undefined : null,
    job: null,
    error: null,
  });
  useEffect(() => {
    if (!channel) return;
    let live = true;
    const settle = (change: Partial<WatchedFolderState>) =>
      live && setState((prev) => ({ ...prev, ...change }));
    channel
      .read()
      .then((folder) => settle({ folder }))
      .catch((error: unknown) =>
        settle({ folder: null, error: error instanceof Error ? error.message : null }),
      );
    channel
      .job()
      .then((job) => settle({ job }))
      .catch(() => settle({ job: null }));
    return () => {
      live = false;
    };
  }, [channel]);
  return state;
}
